import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const nav = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/career-advisory", label: "Career Advisory" },
  { to: "/contact", label: "Contact" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ivory/85 backdrop-blur-md border-b border-[#E0DCD3]" : "bg-transparent"
      }`}
    >
      <div className="container-editorial flex items-center justify-between py-4">
        <Link to="/" data-testid="nav-logo-link">
          <Logo variant="dark" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `font-mono text-[11px] uppercase tracking-[0.22em] pb-1 border-b transition-colors ${
                  isActive
                    ? "border-gold text-charcoal"
                    : "border-transparent text-slate2 hover:text-gold"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/career-advisory" className="btn-primary" data-testid="nav-book-cta">
            Career Advisory · <span className="opacity-70">↗</span>
          </Link>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-[#E0DCD3]" data-testid="nav-mobile-panel">
          <div className="container-editorial py-6 flex flex-col gap-4">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className="font-display text-2xl text-charcoal"
                data-testid={`nav-mobile-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/career-advisory" className="btn-primary mt-3" data-testid="nav-mobile-book">
              Career Advisory (individuals)
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
